import { render, staticRenderFns } from "./Subtitle.vue?vue&type=template&id=242c0a0a"
import script from "./Subtitle.vue?vue&type=script&lang=js"
export * from "./Subtitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports